
<template>
  <div class="body">
    <!-- 已认领包裹 -->
    <baseBreadcrumb :page="$t('message.haveBeenClaimed')" :menu="$t('message.claimAParcel')" />
    <div class="body">
      <div class="search">
        <!-- 开始日期 -->
        <div class="item">
          <el-date-picker v-model="data.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="data.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="['23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 物流号 -->
        <!-- <div class="item">
          <el-input :placeholder="$t('message.logisticsNumber')" v-model="data.express_no">
          </el-input>
                      </div> -->

        <!-- 按钮 -->
        <div class="item">
          <el-button type="primary" @click="search">{{
            $t("message.search")
          }}</el-button>
          <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>
          <!--  认领时间-->
          <el-table-column align="center" :label="$t('message.timeOfClaim')" prop="confirm_at" width="150px">
          </el-table-column>
          <!--  登记时间-->
          <el-table-column align="center" :label="$t('message.registrationTime')" prop="created_at" width="150px">
          </el-table-column>

          <!--  登记人-->
          <el-table-column align="center" :label="$t('message.personOfRegistration')" prop="rowNumber" width="110px">
            <template slot-scope="scope" v-if="scope.row.create_admin">
              <p>{{ scope.row.create_admin.id }}</p>
              <p>{{ scope.row.create_admin.realname }}</p>
            </template>
          </el-table-column>
          <!-- 认领人 -->
          <el-table-column align="center" :label="$t('message.personOfClaim')" prop="rowNumber" width="110px">
            <template slot-scope="scope" v-if="scope.row.confirm_admin">
              <p>{{ scope.row.confirm_admin.id }}</p>
              <p>{{ scope.row.confirm_admin.realname }}</p>
            </template>
          </el-table-column>
          <!-- 关联交易号 -->
          <el-table-column align="center" :label="$t('message.relatedTransactionNumber')" prop="purchase_no">
          </el-table-column>
          <!--  物流号-->
          <el-table-column align="center" :label="$t('message.logisticsNumber')" prop="express_no">
          </el-table-column>
          <!--  包裹图片-->
          <el-table-column align="center" :label="$t('message.pictureOfPackage')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover" v-if="scope.row.package_image">
                <img :src="scope.row.package_image" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="scope.row.package_image" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!--  商品图片-->
          <el-table-column align="center" :label="$t('message.productPicture')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover" v-if="scope.row.goods_image">
                <img :src="scope.row.goods_image" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="scope.row.goods_image" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!--  商品备注-->
          <el-table-column align="center" :label="$t('message.commodityNote')" prop="remark">
          </el-table-column>

          <!--  操作-->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              <!--  -->
              <!-- 打印包裹唛头 -->
              <p>
                <el-button size="small" type="success" @click="printingMarks(scope.row)" v-if="isAuth(313)">{{
                  $t("message.printTheShippingMark")
                }}</el-button>
              </p>

              <!-- 退回待认领 -->
              <p>
                <el-button size="small" type="success" class="dark" @click="returnToBeClaimed(scope.row.id)">{{
                  $t("message.returnToBeClaimed") }}</el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="data.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="data.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 收货-打印包裹信息  -->
    <div v-show="false">
      <PrintparcelinformationReceive ref="PrintparcelinformationReceive" v-if="show" :datas="printData" />
    </div>
  </div>
</template>
<script>
import PrintparcelinformationReceive from '@/components/Printedsheet/PrintparcelinformationReceive'
export default {
  data() {
    return {
      tableData: [{}],

      data: {
        page: 1,
        pageSize: 10,
        status: 2,
        express_no: "",
      },
      total: 0,
      //打印数据
      printData: {},
      show: false,
    };
  },
  components: { PrintparcelinformationReceive },
  created() {
    this.receiveList();
  },
  methods: {
    receiveList() {
      this.$api.signInApi.receiveList(this.data).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(res);
      });
    },

    // 搜索
    search() {
      this.data.page = 1;
      this.receiveList();
    },
    // 重置
    reset() {
      this.data = {
        page: 1,
        pageSize: 10,
        status: 2,
        express_no: "",
      };
      this.receiveList();
    },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
      this.receiveList();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.receiveList();
    },
    //退回待认领
    returnToBeClaimed() { },
    // 打印
    printingMarks(row) {
      this.$api.signInApi.expressPackageInfo({ express_no: row.express_no }).then(res => {
        this.printData = res.data
        this.show = true
        this.$forceUpdate()
        this.$nextTick(() => {
          this.$print(this.$refs.PrintparcelinformationReceive);
        });
      })


    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  display: flex;
  position: relative;

  .item {
    width: 220px;
    margin-right: 24px;

    /deep/.el-date-editor {
      width: 220px;
    }
  }

  .add {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 100px;
    }
  }
}

.content {
  padding: 0 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>